// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"131": "fa42bb9b8616e37e","391": "c3811f59bd703ed8",}[chunkId] + ".js"
}